export const COMPANY_NAME = "T&G LEGACY LAND BUYERS LLC";
export const COMPANY_SHORT = "T&G Legacy Land Buyers";
export const COMPANY_INITIALS = "TLL";
export const COMPANY_ADDRESS_FULL = "1401 21ST St Ste R, Sacramento, California, US 95811-5226";
export const COMPANY_LOCATION = "Sacramento, California";
export const COMPANY_REGION = "Sacramento County, California";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=1401%2021ST%20St%20Ste%20R%2C%20Sacramento%2C%20California%2C%20US%2095811-5226";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Organization", "value": "Limited Liability Company" },
  { "label": "Location", "value": "Sacramento, California" },
  { "label": "Region", "value": "Sacramento County" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "T&G LEGACY LAND BUYERS LLC" },
  { "label": "Location", "value": "Sacramento, California" },
  { "label": "Office address", "value": "1401 21ST St Ste R, Sacramento, California, US 95811-5226" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Public profile", "body": "A concise directory profile built from publicly available organization details." },
  { "icon": "✦", "title": "Sacramento location", "body": "Public office information for the Sacramento, California location." },
  { "icon": "✿", "title": "Directory information", "body": "Organization, location, and address details presented for easy reference." },
  { "icon": "❍", "title": "Visit", "body": "Use the map link to locate the public office address." },
];
